<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-trade__payrecord}">
      <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-form-item label="客户：">
          <el-input
            v-model="dataForm.customerName"
            placeholder="客户名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t("query") }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="showPayDialog()" type="warning"
            >确认收款</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        style="width: 100%"
      >
        <el-table-column
          type="selection"
          header-align="center"
          align="center"
          width="50"
        ></el-table-column>
        <el-table-column
            prop="businessManName"
            label="业务担当"
            header-align="center"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="customerName"
            label="客户名称"
            header-align="center"
            align="center"
        ></el-table-column>
        <el-table-column
          prop="receiptCode"
          label="发票号"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
            label="总金额"
            header-align="center"
            align="center"
        >
          <template v-slot="scope">
            {{moneyFormat(scope.row.amount)}}
          </template>
        </el-table-column>
        <el-table-column
            prop="currency"
            label="货币"
            header-align="center"
            align="center"
        >
        </el-table-column>
        <el-table-column
            prop="shipDate"
            label="出口日期"
            header-align="center"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="realAmount"
            label="收款金额"
            header-align="center"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="operateTime"
            label="收款日期"
            header-align="center"
            align="center"
        ></el-table-column>
        <el-table-column
          prop="imgs"
          label="收款账户"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.accountName">
              收款账户：{{ scope.row.accountName }}
            </div>
            <div v-if="scope.row.accountNo">
              账户信息：{{ scope.row.accountNo }}
            </div>
            <div v-if="scope.row.accountRemark">
              账户备注：{{ scope.row.accountRemark }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="imgs"
          label="凭证"
          header-align="center"
          align="center"
        >
        <template slot-scope="scope">
            <el-image
              v-if="scope.row.imgArr && scope.row.imgArr.length > 0"
              :src="scope.row.imgArr[0]"
              :preview-src-list="scope.row.imgArr"
              class="w-20 h-20"
              fit="contain"
            />
          </template>
        </el-table-column>
<!--        <el-table-column-->
<!--          prop="status"-->
<!--          label="处理状态"-->
<!--          header-align="center"-->
<!--          align="center"-->
<!--        >-->
<!--          <template slot-scope="scope">-->
<!--            <el-tag type="primary">-->
<!--              {{ $dictFormat("pay_record_status", scope.row.status) }}</el-tag-->
<!--            >-->
<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
    </div>
    <PayDialog ref="payDialog" @refreshDataList="getDataList"></PayDialog>
  </el-card>
</template>

<script>
/**代收账款 */
import mixinViewModule from "@/mixins/view-module";
import PayDialog from "./pay-dialog";
import Template from '@/views/page'

export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/trade/payrecord/page/income",
        getDataListIsPage: true,
        exportURL: "/trade/payrecord/export",
        deleteURL: "/trade/payrecord",
        deleteIsBatch: true,
      },
      dataForm: {
        payType: 1,
        customerName: "",
      },
    };
  },
  methods: {
    beforeTableBinding(dataList) {
      dataList.forEach((item) => {
        if (item.imgs) {
          item.imgArr = item.imgs.split(",");
        }
      });
    },
    showPayDialog() {
      if (this.dataListSelections.length === 0) {
        return this.$message.error("请选择对应记录");
      }
      this.$store.state.waitPayList=this.$clone(this.dataListSelections)
      this.$refs.payDialog.init();
    },
  },
  components: { Template, PayDialog },
};
</script>
